module.exports = __webpack_public_path__ + "static/media/ic_twitter_login.3ba2fc29.svg";